import { Box, Button, FormControlLabel, Grid, Icon, IconButton, Switch, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

export function TabConfiguracaoEmpresa({ empresaRaw, control, errors, methods, setTab, mdDown }: any) {
    return (
        <Box>
            <Typography variant="h6" gutterBottom paddingBottom={3}>
                Configuração da Empresa
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="companyConfig.alicota"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Alíquota do Simples Nacional"
                                error={!!errors.companyConfig?.alicota}
                                helperText={errors.companyConfig?.alicota?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="companyConfig.cancelFinancialMovement"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={field.value}
                                        onChange={(e) => field.onChange(e.target.checked)}
                                    />
                                }
                                label="Permitir Cancelamento Financeiro"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="isClt"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!!field.value}
                                        onChange={e => field.onChange(e.target.checked)}
                                    />
                                }
                                label="Empresa utiliza encargos CLT"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="companyConfig.cancellationPeriod"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Período de Cancelamento (dias)"
                                type="number"
                                error={!!errors.companyConfig?.cancellationPeriod}
                                helperText={errors.companyConfig?.cancellationPeriod?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
            </Grid>

            <Box mt={2} display="flex" justifyContent="space-between">
                <Button variant="outlined" onClick={() => setTab(0)}>
                    Voltar
                </Button>
                {empresaRaw?.chargesClt !== null && (
                    <Button variant="contained" onClick={() => setTab(2)}>
                        Próximo: Encargos CLT
                    </Button>
                )}
            </Box>
        </Box>
    )
}